import(/* webpackMode: "eager" */ "/vercel/path0/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["AppKitWrapper"] */ "/vercel/path0/components/appkit-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/vercel/path0/components/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollToTop"] */ "/vercel/path0/components/scroll-to-top.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppSerwistProvider"] */ "/vercel/path0/components/serwist-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/vercel/path0/components/theme-provider.tsx");
